<template>
  <div id="classDetailsDiv">
    <div class="classDetailsDiv_content">
      <div class="head_title class_head_title">
        <div class="query_course_div">
          <!--<button type="button" v-if="publishStatus==1 && classStatus==1" class="btn btn-default btn_option sendMessage" @click="sendMessage()" :disabled="canClickAgain">发送短信</button>-->
          <input class="form-control" placeholder="请输入教师姓名" style="width: 160px;" v-model="queryByTeacherName"/>
          <button type="button" class="btn btn-default btn_option" @click="initTrainingScheduleData()">查询</button>
          <button type="button" class="btn btn-default btn_option btn_export" @click="exportAttendance()">导出班级考勤</button>
          <button type="button" class="btn btn-default btn_option btn_export" @click="exportLesson()">导出培训日程</button>
        </div>
        <div class="head_title_font class_head_title_font">培训日程</div>
      </div>
      <div class="body_content class_body_content">
        <!-- 模态框（Modal） -->
        <div class="modal fade" id="myModal_time" tabindex="-1" role="dialog" aria-labelledby="myModalLabel_time" aria-hidden="true">
          <div class="modal-dialog time_dialog">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                <h4 class="modal-title" id="myModalLabel_time">培训时间</h4>
              </div>
              <div class="modal-body">
                <div style="margin: 10px 0">
                  <label>开始时间：</label>
                  <input type='time' v-validate="'required'" data-vv-scope="selfTime" data-vv-as="开始时间" name="startTime" class="form-control" style="width: 78%" placeholder="开始时间" v-model="selfTime.startTime"/>
                  <span class="validateTip">{{ errors.first('selfTime.startTime') }}</span>
                </div>
                <div style="margin: 10px 0">
                  <label>结束时间：</label>
                  <input type='time' v-validate="'required'" data-vv-scope="selfTime" data-vv-as="开始时间" name="endTime" class="form-control" style="width: 78%" placeholder="结束时间" v-model="selfTime.endTime"/>
                  <span class="validateTip">{{ errors.first('selfTime.endTime') }}</span>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn" @click="chooseTimeOk()">确定</button>
                <button type="button" class="btn" data-dismiss="modal">返回</button>
              </div>
            </div>
          </div>
        </div>

        <!--添加日程模态框-->
        <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content" @click="removeDiv()">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                  &times;
                </button>
                <h4 class="modal-title" id="myModalLabel">
                  <!-- 新增培训日程-->
                  {{schedule_option=='add'?'新增培训日程':'修改培训日程'}}
                </h4>
              </div>
              <div class="modal-body">
                <div class="trainingSchedule_form">
                  <input v-if="classStatus==1 && scheduleStatus=='已结束'" disabled v-validate="'required|date_format:yyyy-MM-dd'" data-vv-scope="training" data-vv-as="培训日期" class="form-control new_date scheduleInfo" size="16" type="text" placeholder="选择日期" readonly v-model="new_schedule.startDate"/>
                  <input v-else v-validate="'required|date_format:yyyy-MM-dd'" data-vv-scope="training" data-vv-as="培训日期" class="form-control new_date scheduleInfo" size="16" type="text" placeholder="选择日期" name="new_schedule_startDate" id="new_schedule_startDate" readonly v-model="new_schedule.startDate" autocomplete="off"/>
                  <span class="spanRed">*</span>
                  <span class="validateTip">{{ errors.first('training.new_schedule_startDate') }}</span>
                  <!--<select v-validate="'required'" data-vv-scope="training" data-vv-as="培训时间" name="time" class="form-control scheduleInfo" v-model="new_schedule.time">
                    <option selected value="">选择时间</option>
                    <option v-for="(les_time,index) in lesson_time" :value="les_time">{{les_time}}</option>
                  </select>-->
                  <input v-if="classStatus==1 && scheduleStatus=='已结束'" disabled name="time" class="form-control scheduleInfo" type="text" placeholder="输入培训时间" v-model="new_schedule.time">
                  <input v-else v-validate="'required'" data-vv-scope="training" data-vv-as="培训时间" name="time" class="form-control scheduleInfo" type="text" placeholder="输入培训时间" v-model="new_schedule.time" @click="showTimeDiv()" autocomplete="off"><!-- @blur="hideTimeDiv()"-->
                  <div id="time_div">
                    <option v-for="(les_time,index) in lesson_time" :key="index" :value="les_time"
                            @click="putTimeData(index)">{{les_time}}</option>
                    <option value="" @click="putTimeData(-1)">自定义</option>
                  </div>
                  <span class="spanRed">*</span>
                  <span class="validateTip">{{ errors.first('training.time') }}</span>


                  <input v-validate="'required'" data-vv-scope="training" data-vv-as="教学内容" name="name" class="form-control scheduleInfo" type="text" placeholder="输入教学内容" v-model="searchCourseName" autocomplete="off"
                         @keyup.enter="addCourse(0)" @keyup.up="addCourse(-1)" @keyup.down="addCourse(1)"  @keyup="loadCourseInputDataWhenAdd($event)" @mouseover="hideCourseDiv()" >
                  <span class="spanRed">*</span>
                  <span class="validateTip">{{ errors.first('training.name') }}</span>
                  <div id="course_div">
                    <option v-for="(courseData, index) in courseInputDataArr" :key="index" :value="courseData.name" :class="index != selectedIndex||'selected'"
                            @click="chooseCourse(courseData)">{{courseData.name}}</option>
                  </div>

                  <!--   <span class="spanRed">*</span>
                     <span class="validateTip">{{ errors.first('training.name') }}</span>-->


                  <!--<input class="form-control scheduleInfo" type="text" placeholder="输入主讲教师" v-model="searchTeacherName" @keyup="loadQueryInputDataWhenAdd()" @focus="loadQueryInputDataWhenAdd()" style="margin-left: -12px">&lt;!&ndash; @click="showTeachersDiv" @blur="hideTeachersDiv()"&ndash;&gt;-->
                  <!--<span class="spanRed">*</span>-->

                  <!--<div class="panel panel-default">-->
                  <!--<div class="panel-heading">-->
                  <div class="">
                  <input class="form-control scheduleInfo tea_input" type="text" placeholder="输入主讲教师" v-model="searchTeacherName" @keyup.enter="addTeacher(0)" @keyup.up="addTeacher(-1)" @keyup.down="addTeacher(1)"  @keyup="loadQueryInputDataWhenAdd(0, $event)" @focus="loadQueryInputDataWhenAdd(0)" autocomplete="off">
                  <button type="button" class="btn btn-default btn_option okBtn" @click="addTeacher(0)">确定</button>
                  </div>
                  <!-- <span class="spanRed teacher_span">*</span>
                   <span class="validateTip">{{ errors.first('training.teacherName') }}</span>-->
                  <!--v-validate="'required'" data-vv-scope="training" data-vv-as="主讲老师" data-vv-name="teacherName" v-model="searchTeacherName"-->
                  <div>
                    <div class="teacher_name_div" v-for="(chooseTeacherOne, index) in checkbox.teacherNames">
                        {{chooseTeacherOne}}<span v-if="!checkbox.checkIds[index] || checkbox.teaTypes[index]== '1'">(外聘)</span>
                        <div class="glyphicon glyphicon-remove" @click="deleteTeacherById(index)">
                      </div>
                    </div>
                  </div>
                  <!-- </div>
                 </div>-->


                  <!-- <div id="teachers_div" v-if="teacherFlag == 0">
                     <option v-for="(queryData, index) in queryInputDataArr" :key="index" :value="queryData.userName"
                             @click="putTeacherData(index)">{{queryData.userName}}-{{queryData.mobile}}</option>
                   </div>-->

                  <!--<div id="teaCourse_div" v-else-if="teacherFlag == 1">
                    <select id="myselect" multiple="multiple" size="2">
                    <option v-for="(courseTeaData, index) in courseInputDataArr" :key="index" :value="courseTeaData.teadherName"
                            @click="putTeaCourseData(index)">{{courseTeaData.teadherName}}</option>
                    </select>
                  </div>-->

                  <!--课程库教师列表-->
                  <div id="teachers_div">
                    <option v-for="(queryData, index) in queryInputDataArr" :key="index" :value="queryData.userName" :class="index != selectedIndex||'selected'"
                            @click="chooseTeachers(queryData.id,queryData.userName,'0')" v-if="!queryData.hasOwnProperty('teaType')">{{queryData.userName}}-{{queryData.mobile}}</option>
                    <option v-for="(queryData, index) in queryInputDataArr" :key="index" :value="queryData.name" :class="index != selectedIndex||'selected'"
                            @click="chooseTeachers(queryData.id,queryData.name,'1')" v-if="queryData.hasOwnProperty('teaType')">{{queryData.name}}<span v-if="queryData.mobile">-{{queryData.mobile}}</span>（外聘）</option>
                  </div>

                  <!--报课教师列表-->
                  <!-- <div id="teaCourse_div" v-else-if="teacherFlag == 1">
                     <table class="table table-bordered table-striped teaCourse_table_action">
                       <tbody>
                       <tr v-for="(courseTeaData, index) in courseInputDataArr" :key="index" :value="courseTeaData.teadherName">
                         <td>
                           <input type="checkbox" checked="checked" :checked="checkbox.checkIds.indexOf(courseTeaData.teadherId)>=0" @click="checkedOne(courseTeaData.teadherId,courseTeaData.teadherName)">
                         </td>
                         <td>{{courseTeaData.teadherName}}</td>
                       </tr>
                       <tr>
                         <td>
                           <button type="button" class="btn btn-default btn_option teacherBtn" @click="teaCourseDivHide()">确认</button>
                         </td>
                       </tr>
                       </tbody>
                     </table>
                   </div>-->


                  <input v-validate="'required'" data-vv-scope="training" data-vv-as="上课地点" readonly name="roomName" class="form-control scheduleInfo" type="text" placeholder="选择上课地点" v-model="new_schedule.roomName" @click="room_step='place';isShowRoomDiv = true" autocomplete="off">
                  <span class="spanRed">*</span>
                  <div class="room_div" :class="{isShowRoomDivClass: isShowRoomDiv}">
                    <ul id="myTab" class="nav nav-tabs">
                      <li v-for="(place, index_p) in placeList" :key="index_p" @click="placeId=place.id,selectPlace(index_p)" :class="{havenClick: place.id == placeId}">
                        {{place.name}}
                      </li>
                    </ul>
                    <div id="myTabContent" class="tab-content">
                      <ul id="myTab_" class="nav nav-tabs">
                        <li v-for="(rooms, index_r) in roomsList" :key="index_r" @click="roomId=rooms.id,selectRooms(index_r)" :class="{havenClick: rooms.id == roomId}">
                          {{rooms.name}}
                        </li>
                      </ul>
                    </div>
                  </div>
                  <span class="validateTip">{{ errors.first('training.roomName') }}</span>

                  <select class="form-control scheduleInfo" name="type" v-model="new_schedule.type">
                    <option value="">选择课程类型</option>
                    <option v-for="(lessonType, key, index) in lesson_type" :value="key">{{lessonType}}</option>
                  </select>
                  <span class="spanRed">&nbsp;</span>
                </div>
                <form class="form-horizontal" role="form" style="margin: 50px 0 0 0;">
                  <div class="form-group">
                    <!--1.班级状态处于开班中、已结业，该课程还未开始上，修改该课程时，要正确显示“考勤”和“评估”的勾选状态，且可以正常修改
                        2.班级状态处于开班中、已结业，该课程在上课中或者已结束，修改该课程时，要正确显示“考勤”和“评估”的勾选状态，但不可修改-->
                    <div class="col-sm-12">
                      <label class="checkbox-inline">
                        <input type="checkbox" :disabled="(classStatus !='0' && scheduleStatus=='已结束') || (classStatus !='0' && scheduleStatus=='上课中')" name="attendance_one" id="attendance_one" v-bind:true-value="1" v-bind:false-value="3" v-model="attendanceValueOne" @click="changeAttendanceValue()"> 考勤
                      </label>
                      <label class="checkbox-inline">
                        <input type="checkbox" :disabled="(classStatus !='0' && scheduleStatus=='已结束') || (classStatus !='0' && scheduleStatus=='上课中')" name="attendance_two" id="attendance_two" v-bind:true-value="1" v-bind:false-value="3" v-model="attendanceValueTwo" @click="changeAttendanceValue()"> 评估
                      </label>
                    </div>
                  </div>
                </form>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-default btn_save" @click="saveSchedule()">确定</button>
                <button type="button" class="btn btn-default btn_cancel" @click="cancelSaveSchedule()">取消</button>
              </div>
            </div>
          </div>
        </div>

        <!--课程库教师模态框-->
        <div class="modal fade" id="myModal_course" tabindex="-1" role="dialog" aria-labelledby="myModalLabel_course" aria-hidden="true">
          <div class="modal-dialog course_dialog">
            <div class="modal-content course_content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                  &times;
                </button>
                <h4 class="modal-title" id="myModalLabel_course">
                  选择教师
                </h4>
              </div>
              <div class="modal-body course_body">
                <!--课程库教师列表-->
                <div id="teachers_div_">
                  <option v-for="(queryData, index) in queryInputDataArr" :key="index" :value="queryData.teacherId" :class="{'selected':checkbox.checkIds.indexOf(queryData.teacherId)>=0}"
                          @click="chooseTeachers(queryData.teacherId,queryData.teacherName,queryData.teaType, checkbox.checkIds.indexOf(queryData.teacherId)>=0)">{{queryData.teacherName}}</option>
                </div>

                <!--报课教师列表-->
                <!--<div id="teaCourse_div" v-else-if="teacherFlag == 1">
                  <table class="table table-bordered table-striped teaCourse_table_action">
                    <tbody>
                    <tr v-for="(courseTeaData, index) in courseInputDataArr" :key="index" :value="courseTeaData.teadherName">
                      <td>
                        <input type="checkbox" checked="checked" :checked="checkbox.checkIds.indexOf(courseTeaData.teadherId)>=0" @click="checkedOne(courseTeaData.teadherId,courseTeaData.teadherName)">
                      </td>
                      <td>{{courseTeaData.teadherName}}</td>
                    </tr>
                    <tr>
                      <td>
                        <button type="button" class="btn btn-default teacherBtn" @click="teaCourseDivHide()">确认</button>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>-->
              </div>
              <!--<div class="modal-footer course_footer">
                <button type="button" class="btn btn-default btn_save"  @click="teaCourseDivHide()">确定</button>
                <button type="button" class="btn btn-default btn_cancel" @click="hideTeacherModal()">取消</button>
              </div>-->
            </div>
          </div>
        </div>

        <!--考勤详情模态框-->
        <div class="modal fade" id="myModal_attendance" tabindex="-1" role="dialog" aria-labelledby="myModalLabel_attendance" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content details_content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                  &times;
                </button>
                <h4 class="modal-title" id="myModalLabel_attendance">
                  {{new_schedule.name}}
                </h4>
              </div>
              <div class="modal-body">
                <div class="body_top">
                  <span>日期：{{new_schedule.startDate}}</span>
                  <span>时间：{{new_schedule.time}}</span>
                  <!--<span>教学内容：{{new_schedule.name}}</span>-->
                  <span>主讲老师：{{new_schedule.teacherName}}</span>
                </div>
                <table class="table table-bordered table-striped details_table">
                  <thead>
                  <tr>
                    <th width="15%">姓名</th>
                    <th width="25%">工作单位</th>
                    <th width="20%">签到时间</th>
                    <th width="10%">签到结果</th>
                    <th width="20%">签退时间</th>
                    <th width="10%">签退结果</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(attendanceDetailOne, index) in attendanceDetailsList" :key="index">
                    <td width="15%">{{attendanceDetailOne.studentName}}</td>
                    <td width="25%">{{attendanceDetailOne.department}}</td>
                    <td width="20%"><!--签到时间-->
                      <span v-if="attendanceDetailOne.result1 != '3' && attendanceDetailOne.checkTime2">{{attendanceDetailOne.checkTime1}}</span>
                      <span v-else-if="(attendanceDetailOne.checkTime1 != '' && attendanceDetailOne.checkTime2 == '')"></span>
                      <span v-else></span>
                    </td>
                    <!--0: 正常, 1: 迟到, 2: 早退, 3: 请假, 4: 旷课-->
                    <td width="10%"><!--签到结果-->
                      <span v-if="attendanceDetailOne.result1 && attendanceDetailOne.result2">{{attendanceDetailOne.result1 |formatAttendanceStatus}}</span>
                      <span v-else-if="attendanceDetailOne.result1 =='3'">请假</span>
                      <!--<span v-else-if="attendanceDetailOne.checkTime1 !='' && attendanceDetailOne.checkTime2 ==''">旷课</span>-->
                      <span v-else>旷课</span>
                    </td>
                    <td width="20%"><!--签退时间-->
                      <span v-if="attendanceDetailOne.result1 != '3'">{{attendanceDetailOne.checkTime2}}</span>
                      <span v-else></span>
                    </td>
                    <td width="10%">{{attendanceDetailOne.result2 |formatAttendanceStatus}}</td><!--签退结果-->
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <button type="button" class="btn btn-default btn_option add_unit" v-if="classStatus != -1 && classInfoEditFlag==1" @click="isAddTrainingSchedule = true;addUnitBtn();">+新增单元</button>
        <button type="button" class="btn btn-default btn_option add_unit" v-if="classStatus != -1 && classInfoEditFlag==1" @click="validateAllLesson();">冲突验证</button>
        <button type="button" class="btn btn-default btn_option add_unit" v-if="changeLessonStatus == 1" @click="changeLessonClear();">取消调课</button>
        <!--结业前-->
        <div v-if="classStatus != -1 && classInfoEditFlag==1" class="unit_all">
          <div class="unit_one" v-for="(training, index) in trainingScheduleList" :key="index">
            <div class="unit_one_content_header_div">
              <!--<strong class="unit_name_title">{{training.name}}</strong>-->
              <div class="unit_action">
                <button type="button" class="btn btn-default btn_option okBtn" @click="updateUnitMsg(index)">确定</button>
                <button type="button" class="btn btn-default btn_option okBtn" @click="delete_unit_id=training.id;deleteUnitMsg()">删除</button>
              </div>
              <div class="form-group-div">
                <div class="form-group">
                  <label class="unit_content_label_name">单元名称:</label><!--"'unit'+index"--><!--'unit'+index+'.name'-->
                  <input v-validate="'required|maxL:80'" :data-vv-scope="'unit'+index" data-vv-as="单元名称" name="name" class="form-control" v-model="training.name" style="resize: none"></input>
                  <span class="spanRed">*</span>
                  <span class="validateTip validateTip_unit">{{ errors.first('unit'+index+'.name') }}</span>
                </div>

                <div class="form-group">
                  <label class="unit_content_label">单元内容:</label>
                  <textarea v-validate="'maxL:300'" :data-vv-scope="'unit'+index" data-vv-as="单元内容" name="content" class="form-control" v-model="training.content" style="resize: none"></textarea>
                  <span class="spanRed"></span>
                  <span class="validateTip validateTip_unit">{{ errors.first('unit'+index+'.content') }}</span>
                </div>
                <div class="form-group">
                  <label>起止日期:</label>
                  <input v-validate="{date_format:'yyyy-MM-dd',beforeDate:['结束日期',training.endDate]}" :data-vv-scope="'unit'+index" data-vv-as="开始日期" ref="beforeDateTarget_up" class="form-control new_date" size="16" type="text" name="startDate" :id="gernerateId_start(training.id, index)" readonly v-model="training.startDate"/>
                  <span class="spanRed"></span>
                  ——
                  <input v-validate="'date_format:yyyy-MM-dd|afterDate:开始时间'" :data-vv-scope="'unit'+index" data-vv-as="结束日期" ref="afterDateTarget_up" class="form-control new_date" size="16" type="text" name="endDate" :id="gernerateId_end(training.id, index)" readonly v-model="training.endDate"/>
                  <span class="spanRed"></span>
                  <span class="validateTip validateTip_unit">{{ errors.first('unit'+index+'.startDate') }}</span>
                  <span class="validateTip validateTip_unit">{{ errors.first('unit'+index+'.endDate') }}</span>
                </div>
                <div class="form-group">
                  <label>教学责任科室:</label>
                  <input type="text" v-validate="" :data-vv-scope="'unit'+index" data-vv-as="教学责任科室" name="department" class="form-control" v-model="training.department">
                  <span class="spanRed"></span>
                  <span class="validateTip validateTip_unit">{{ errors.first('unit'+index+'.department') }}</span>
                </div>
                <div class="form-group">
                  <label>教学方式:</label>
                  <input type="text" v-validate="" :data-vv-scope="'unit'+index" data-vv-as="教学方式" name="mode" class="form-control" v-model="training.mode">
                  <span class="spanRed"></span>
                  <span class="validateTip validateTip_unit">{{ errors.first('unit'+index+'.mode') }}</span>
                </div>
              </div>
            </div>
            <table class="table table-striped table-bordered lesson_table">
              <tbody>
              <tr>
                <th width="5%">序号</th>
                <th width="12%">日期</th>
                <th width="12%">时间</th>
                <th>教学内容</th>
                <th width="8%">主讲教师</th>
                <th width="10%">上课地点</th>
                <th width="20%">操作</th>
              </tr>
              <tr v-for="(less, index_less) in training.lessons" :key="index_less">
                <td>{{index_less+1}}</td>
                <td>{{less.startDate}}</td>
                <td>{{less.time}}</td>
                <td>{{less.name}}</td>
                <td>{{less.teacherName}}</td>
                <td>{{less.roomName}}</td>
                <td v-if="publishStatus == 1 && classStatus == 1">
                  <button type="button" class="btn btn-default btn_option okBtn" v-if="changeLessonStatus == 1 && changeLessonInTwoData[0] && changeLessonInTwoData[0].id!=less.id" @click="changeLessonSelect(less)">对调</button>
                  <button type="button" class="btn btn-default btn_option okBtn" v-if="changeLessonStatus == 0" @click="changeLessonStart(less)">调课</button>
                  <button type="button" class="btn btn-default btn_option okBtn"  v-if="less.status != '已结束'&& changeLessonStatus == 0"  @click="notice(less.id)">通知</button>
                  <button type="button" class="btn btn-default btn_option okBtn" v-if="changeLessonStatus == 0" @click="update_schedule_id=less.id;schedule_option='update';updateSchedeleMsg(less.status)">修改</button>
                  <button type="button" class="btn btn-default btn_option okBtn" v-if="changeLessonStatus == 0" @click="delete_schedule_id=less.id;deleteSchedeleMsg()">删除</button>
                  <button type="button" class="btn btn-default btn_option okBtn" v-if="less.status == '已结束' && changeLessonStatus == 0" data-toggle="modal" data-target="#myModal_attendance" @click="initAttendanceDetailsList(less.id,less.startDate,less.time,less.name,less.teacherName)">考勤记录</button>
                </td>
                <td v-else>
                  <button type="button" class="btn btn-default btn_option okBtn" @click="update_schedule_id=less.id;new_schedule.status=less.status;schedule_option='update';updateSchedeleMsg(less.status)">修改</button>
                  <button type="button" class="btn btn-default btn_option okBtn" @click="delete_schedule_id=less.id;deleteSchedeleMsg()">删除</button>
                </td>
              </tr>
              </tbody>
            </table>
            <button type="button" class="btn-default btn_option add_schedule" @click="new_schedule.unitId=training.id;schedule_option='add';showAddScheduleModal()">+添加日程</button>
          </div>

          <div class="unit_one" v-if="trainingScheduleList.length == 0 || isAddTrainingSchedule">
            <div class="unit_one_content_header_div">
              <!--<strong style="margin-bottom: 10px;font-size: 18px">{{unit_name_arr[trainingScheduleList.length]}}</strong>-->
              <div class="unit_action">
                <button type="button" class="btn btn-default btn_option okBtn" @click="saveUnitMsg()">确定</button>
                <button type="button" class="btn btn-default btn_option okBtn" @click="isAddTrainingSchedule = false">删除</button>
              </div>
              <div class="form-group-div">
                <div class="form-group">
                  <label class="unit_content_label_name">单元名称:</label>
                  <input v-validate="'required|maxL:80'" data-vv-scope="addUnit" data-vv-as="单元名称" name="name" class="form-control" v-model="new_unit.name" style="resize: none"></input>
                  <span class="spanRed">*</span>
                  <span class="validateTip validateTip_unit">{{ errors.first('addUnit.name')}}</span>
                </div>

                <div class="form-group">
                  <label class="unit_content_label">单元内容:</label>
                  <textarea v-validate="'maxL:300'" data-vv-scope="addUnit" data-vv-as="单元内容" name="content" class="form-control" v-model="new_unit.content" style="resize: none"></textarea>
                  <span class="spanRed"></span>
                  <span class="validateTip validateTip_unit">{{ errors.first('addUnit.content') }}</span>
                </div>
                <div class="form-group">
                  <label>起止日期:</label>
                  <input v-validate="{date_format:'yyyy-MM-dd',beforeDate:['结束日期',new_unit.endDate]}" data-vv-scope="addUnit" data-vv-as="开始日期" ref="beforeDateTarget" class="form-control new_date" size="16" type="text" name="startDate" id="startDate" readonly v-model="new_unit.startDate"/>
                  <span class="spanRed"></span>
                  ——
                  <input v-validate="'date_format:yyyy-MM-dd'" data-vv-scope="addUnit" data-vv-as="结束日期" ref="afterDateTarget" class="form-control new_date" size="16" type="text" name="endDate" id="endDate" readonly v-model="new_unit.endDate"/>
                  <span class="spanRed"></span>
                  <span class="validateTip validateTip_unit">{{ errors.first('addUnit.startDate') }}</span>
                  <span class="validateTip validateTip_unit">{{ errors.first('addUnit.endDate') }}</span>
                </div>
                <div class="form-group">
                  <label>教学责任科室:</label>
                  <input type="text" v-validate="" data-vv-scope="addUnit" data-vv-as="教学责任科室" name="department" class="form-control" v-model="new_unit.department">
                  <span class="spanRed"></span>
                  <span class="validateTip validateTip_unit">{{ errors.first('addUnit.department') }}</span>
                </div>
                <div class="form-group">
                  <label>教学方式:</label>
                  <input type="text" v-validate="" data-vv-scope="addUnit" data-vv-as="教学方式" name="mode" class="form-control" v-model="new_unit.mode">
                  <span class="spanRed"></span>
                  <span class="validateTip validateTip_unit">{{ errors.first('addUnit.mode') }}</span>
                </div>
              </div>
            </div>
            <!--<table class="table table-striped table-bordered">
              <tbody>
              <tr>
                <th>序号</th>
                <th>日期</th>
                <th>时间</th>
                <th>教学内容</th>
                <th>主讲老师</th>
                <th>上课地点</th>
                <th width="150px">操作</th>
              </tr>
              <tr></tr>
              </tbody>
            </table>
            <button type="button" class="btn-default add_schedule " @click="'请先保存单元数据'.showMessage()">+添加日程</button>-->
          </div>
          <div id="comment" style="height: 320px;"></div>
        </div>

        <!--已结业-->
        <div v-else class="unit_all">
          <div class="unit_one" v-for="(training, index) in trainingScheduleList" :key="index">
            <div class="unit_one_content_header_div">
              <!--<strong class="unit_name_title">{{training.name}}</strong>-->
              <div class="unit_action"></div>
              <div class="form-group-div">
                <div class="form-group add_unit_name">
                  <label>单元名称:</label>
                  {{training.name}}
                </div>
                <div class="form-group">
                  <label>单元内容:</label>
                  {{training.content}}
                </div>
                <div class="form-group">
                  <label>起止日期:</label>
                  {{training.startDate}}
                  ——
                  {{training.endDate}}
                </div>
                <div class="form-group">
                  <label>教学责任科室:</label>
                  {{training.department}}
                </div>
                <div class="form-group">
                  <label>教学方式:</label>
                  {{training.mode}}
                </div>
              </div>
            </div>
            <table class="table table-striped table-bordered">
              <tbody>
              <tr>
                <th>序号</th>
                <th>日期</th>
                <th>时间</th>
                <th>教学内容</th>
                <th>主讲教师</th>
                <th>上课地点</th>
                <th width="20%">操作</th>
              </tr>
              <tr v-for="(less, index_less) in training.lessons" :key="index_less">
                <td>{{index_less+1}}</td>
                <td>{{less.startDate}}</td>
                <td>{{less.time}}</td>
                <td>{{less.name}}</td>
                <td>{{less.teacherName}}</td>
                <td>{{less.roomName}}</td>
                <td>
                  <button type="button" v-if="classInfoEditFlag==1" class="btn btn-default btn_option okBtn" @click="update_schedule_id=less.id;schedule_option='update';updateSchedeleMsg(less.status)">修改</button>
                  <button type="button" v-if="classInfoEditFlag==1" class="btn btn-default btn_option okBtn" @click="delete_schedule_id=less.id;deleteSchedeleMsg()">删除</button>
                  <button type="button" v-if="less.status == '已结束'"  class="btn btn-default btn_option detailBtn" data-toggle="modal" data-target="#myModal_attendance" @click="initAttendanceDetailsList(less.id,less.startDate,less.time,less.name,less.teacherName)">查看考勤记录</button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {schoolAxios} from "../main";

  import {getContentSize} from './mainView';

  import dictionaryData from '../json/dictionary';

  import {Validator} from 'vee-validate';

  export default {
    name: "classBasisBefore",
    data() {
      return {
        clazzId: this.$store.state.clazzId,
        publishStatus: this.$store.state.publishStatus,
        classStatus: this.$store.state.classStatus,
        //是否可编辑flag
        classInfoEditFlag:this.$store.state.classInfoEditFlag,
        token: this.$store.state.access_token,

        //上课教师搜索
        searchTeacherName: '',
        queryInputDataArr: [],

        //课程库课程名称搜索
        searchCourseName:'',
        searchCourseNameComplete:false,

        selectedIndex: -1,
        //课程类型
        lesson_type: dictionaryData.lesson_type,
        //培训日程搜索
        queryByTeacherName:'',

        //课程库集合
        courseInputDataArr:[],
        //教师falg
        teacherFlag:0,
        //教师ids
        checkbox: {
          checkIds: [],
          teacherNames:[],
          teaTypes:[]
        },

        /*teaName:{
          teacherNames:[]
        },*/

        //今日日期
        timeDate: '',

        //单元名称数组
        unit_name_arr : ['一单元','二单元','三单元','四单元','五单元','六单元','七单元','八单元','九单元','十单元',
          '十一单元','十二单元','十三单元','十四单元','十五单元','十六单元','十七单元','十八单元','十九单元','二十单元',
          '二十一单元','二十二单元','二十三单元','二十四单元','二十五单元','二十六单元'],

        //是否添加培训日程
        isAddTrainingSchedule: false,

        //上课时间数组
        lesson_time: dictionaryData.lesson_time,
        //日程
        new_schedule: {
          unitId: '',
          id: '',
          startDate: '',
          time: '',
          name: '',
          teacherId: '',
          teaType: '',
          teacherName: '',
          roomId: '',
          roomName: '',
          type:'',
          isAttendance:'1',
        },
        scheduleStatus:'',

        //日程添加修改操作
        schedule_option: '',

        //删除单元ID
        delete_unit_id: '',

        //修改日程ID
        update_schedule_id: '',
        //删除日程ID
        delete_schedule_id: '',

        //培训单元日程数据集合
        trainingScheduleList: [],

        //添加单元
        new_unit: {
          id: '',
          name:'',
          content: '',
          startDate: '',
          endDate: '',
          department: '',
          mode: ''
        },

        //选择教师步骤
        room_step: 'place',

        isShowRoomDiv : false,
        //教师场所数据集合
        placeList: [],
        //教室集合
        roomsList: [],

        placeId: '',
        roomId: '',

        selfTime: {
          startTime: '',
          endTime: ''
        },

        /*考勤详情集合*/
        attendanceDetailsList:[],

        hrefExport:this.$store.state.serviceBase+"resources/",

        //考勤状态
        attendance_status:dictionaryData.attendance_status,

        //排课提醒flag
        canClickAgain: false,

        //时间间隔
        timeNum: '',

        attendanceValueOne:'1',
        attendanceValueTwo:'1',
        //调课状态 0 关闭 1开启
        changeLessonStatus : 0,
        changeLessonInTwoData: [],

      }
    },
    filters: {
      formatAttendanceStatus(value){
        let this_ = this;
        if(dictionaryData.attendance_status && value){
          value = dictionaryData.attendance_status[value];
        }
        return value;
      }
    },
    created: function () {

    },
    mounted: function () {
      let this_ = this;
      this.$nextTick(function () {
        getContentSize();

        this_.closeModal();

        this_.initTrainingScheduleData();
        this_.loadPlace();

        // this_.loadValidator();


      });
    },
    updated: function () {
      let this_ = this;
      //日期
      this_.dateDefault();

    },
    methods: {
      /**
       * isAttendance
       * 1：不考勤不评估
       * 2：考勤且评估
       * 3: 考勤不评估
       * */
      changeAttendanceValue(){
        let attendance_one = document.getElementById("attendance_one").checked;
        let attendance_two = document.getElementById("attendance_two").checked;
        if(attendance_two){
          this.attendanceValueOne = 1;
        }
        if(!attendance_one){
          this.attendanceValueTwo=3;
        }
      },
      attendanceSaveCul:function(){
        /* if(this.attendanceValueOne == 3 && this.attendanceValueTwo==3){
           this.new_schedule.isAttendance = 1;
         }else if(this.attendanceValueOne == 1 && this.attendanceValueTwo==1){
           this.new_schedule.isAttendance = 2;
         }else if(this.attendanceValueOne == 1 && this.attendanceValueTwo==3){
           this.new_schedule.isAttendance = 3;
         }*/
        if(this.attendanceValueOne == 3 && this.attendanceValueTwo==3){
          this.new_schedule.isAttendance = 3;
        }else if(this.attendanceValueOne == 1 && this.attendanceValueTwo==1){
          this.new_schedule.isAttendance = 1;
        }else if(this.attendanceValueOne == 1 && this.attendanceValueTwo==3){
          this.new_schedule.isAttendance = 2;
        }
      },
      attendanceLoadCul:function(isAttendance){
        // console.log("####:" + isAttendance);
        /* if(isAttendance == 1){
           this.attendanceValueOne = 3;
           this.attendanceValueTwo = 3;
         }else if(!isAttendance || isAttendance == 2){
           this.attendanceValueOne = 1;
           this.attendanceValueTwo = 1;
         }else if(isAttendance == 3){
           this.attendanceValueOne = 1;
           this.attendanceValueTwo = 3;
         }*/
        if(isAttendance == 1){
          this.attendanceValueOne = 1;
          this.attendanceValueTwo = 1;
        }else if(!isAttendance || isAttendance == 2){
          this.attendanceValueOne = 1;
          this.attendanceValueTwo = 3;
        }else if(isAttendance == 3){
          this.attendanceValueOne = 3;
          this.attendanceValueTwo = 3;
        }
      },

      /**
       * 初始加载培训日程
       */
      initTrainingScheduleData(){
        let this_ = this;
        schoolAxios({
          method: 'get',
          url: 'unit/findDetailsListBy',
          params: {
            'clazzId': this_.clazzId,
            'paramTeacherName':this_.queryByTeacherName
          }
        }).then(function (resp) {
          let data = resp.data;
          if(data.success){
            this_.trainingScheduleList = data.list;
            console.log('--------------trainingScheduleList:',this_.trainingScheduleList)
            /*this_.trainingScheduleList.forEach(function (elem) {
              if(elem.teacherId == null){
                elem.teacherName = elem.teacherName + '(外聘)';
              }
            })*/
            for(let i = 0;i<this_.trainingScheduleList.length;i++){
              for(let j = 0;j<this_.trainingScheduleList[i].lessons.length;j++){
                let teacherIds = this_.trainingScheduleList[i].lessons[j].teacherId?this_.trainingScheduleList[i].lessons[j].teacherId.split(","):[];
                let teacherNames = this_.trainingScheduleList[i].lessons[j].teacherName?this_.trainingScheduleList[i].lessons[j].teacherName.split(","):[];
                let teaTypes = this_.trainingScheduleList[i].lessons[j].teaType?this_.trainingScheduleList[i].lessons[j].teaType.split(","):[];
                if(teacherNames.length>0){
                  teacherIds.length = teacherNames.length;
                }
                teacherNames.forEach(function (t, k) {
                  if(teaTypes[k]=='1' || !teacherIds[k]){
                    teacherNames[k] = teacherNames[k]+ '(外聘)';
                  }
                })
                this_.trainingScheduleList[i].lessons[j].teacherName = teacherNames.toString();
              }
            }
          }
        });
      },
      /**
       * 加载教师场所
       */
      loadPlace(){
        let this_ = this;
        schoolAxios({
          method: 'get',
          url: 'place/findList',
          params: {}
        }).then(function (resp) {
          let data = resp.data;
          if(data.success){
            this_.placeList = data.list;
          }
        });
      },
      /**
       * 选择教学场所
       */
      selectPlace(index){
        let this_ = this;
        let my_data = this_.placeList[index];

        this_.new_schedule.roomName = my_data.name+":";

        schoolAxios({
          method: 'get',
          url: 'rooms/findList',
          params: {
            placeId: my_data.id
          }
        }).then(function (resp) {
          let data = resp.data;
          if(data.success){
            this_.room_step = "rooms";
            this_.roomsList = data.list;
          }
        });
      },
      /**
       * 选择教室
       */
      selectRooms(index){
        let this_ = this;
        let my_data = this_.roomsList[index];

        this_.new_schedule.roomId = my_data.id;
        this_.new_schedule.roomName += my_data.name;

        this_.room_step = "place";
        this_.isShowRoomDiv = false;
      },
      /**
       * 点击添加单元按钮事件
       */
      addUnitBtn(){
        let this_ = this;
        this_.new_unit = {
          id: '',
          name:'',
          content: '',
          startDate: '',
          endDate: '',
          department: '',
          mode: ''
        }
        const returnEle = document.querySelector("#comment");
        if (!!returnEle) {
          returnEle.scrollIntoView(true);
        }
      },
      /**
       * 保存单元
       */
      saveUnitMsg(){
        let this_ = this;
        this_.$validator.validateAll('addUnit').then(result => {
          if (result) {
            schoolAxios({
              url: 'unit/add',
              data: {
                id: this_.new_unit.id,
                clazzId: this_.clazzId,
                /*name: this_.unit_name_arr[this_.trainingScheduleList.length],*/
                name:this_.new_unit.name,
                content: this_.new_unit.content,
                startDate: this_.new_unit.startDate,
                endDate: this_.new_unit.endDate,
                department: this_.new_unit.department,
                mode: this_.new_unit.mode
              }
            }).then(function (resp) {
              let data = resp.data;
              if (data.success) {
                this_.isAddTrainingSchedule = false;
                "保存成功".showMessage();
                this_.initTrainingScheduleData();
              } else {
                (data.message || "保存失败").showMessage();
              }
            });
          }
        });
      },
      /**
       * 修改单元
       */
      updateUnitMsg(index){
        let this_ = this;
        this_.$validator.validateAll('unit' + index ).then(result => {
          if (result) {
            let updateData = this_.trainingScheduleList[index];
            schoolAxios({
              method: 'put',
              url: 'unit/edit',
              data: {
                id: updateData.id,
                clazzId: this_.clazzId,
                name: updateData.name,
                content: updateData.content,
                startDate: updateData.startDate,
                endDate: updateData.endDate,
                department: updateData.department,
                mode: updateData.mode
              }
            }).then(function (resp) {
              let data = resp.data;
              if (data.success) {
                "保存成功".showMessage();
                this_.initTrainingScheduleData();
              } else {
                (data.message || "保存失败").showMessage();
              }
            })
          }
        });
      },
      /**
       * 删除单元
       */
      deleteUnitMsg(){
        let this_ = this;
        "确定删除单元及单元日程数据".showConfirm(function () {
          schoolAxios({
            method: 'delete',
            url: 'unit/delete/'+this_.delete_unit_id,
            params: {}
          }).then(function (resp) {
            let data = resp.data;
            if(data.success){
              this_.initTrainingScheduleData();
            }else{
              "删除失败".showMessage();
            }
          });
        });
      },
      showAddScheduleModal(){
        this.checkbox.checkIds=[];
        this.checkbox.teacherNames=[];
        this.checkbox.teaTypes=[];
        $("#myModal").modal("show");
      },
      /**
       * 保存日程
       */
      saveSchedule(){
        let this_ = this;
        this_.$validator.validateAll('training').then(result => {
          if (result) {
            let method = '';
            let url = "";
            if (this_.schedule_option == "add") {
              method = 'post';
              url = 'lesson/add';
            } else {
              method = 'put';
              url = 'lesson/edit';
            }
            this_.new_schedule.teacherId = this_.checkbox.checkIds.toString();
            this_.new_schedule.teacherName = this_.checkbox.teacherNames.toString();
            this_.new_schedule.teaType = this_.checkbox.teaTypes.toString();

            // if(this_.new_schedule.teacherName == ""){
            //   this_.new_schedule.teacherName = this_.searchTeacherName;
            //   /*this_.new_schedule.name = this_.searchCourseName;*/
            // }
            // if(this_.new_schedule.teacherName == ""){
            //   this_.new_schedule.teacherName = this_.searchTeacherName;
            // }
            if(this_.new_schedule.name == ""){
              this_.new_schedule.name = this_.searchCourseName;
            }
            this_.attendanceSaveCul();
            schoolAxios({
              method: method,
              url: url,
              data: {
                clazzId: this_.clazzId,
                unitId: this_.new_schedule.unitId,
                id: this_.new_schedule.id,
                startDate: this_.new_schedule.startDate,
                time: this_.new_schedule.time,
                name: this_.new_schedule.name,
                courseId: this_.new_schedule.courseId,
                takeHours: this_.new_schedule.takeHours,
                teacherId: this_.new_schedule.teacherId,
                teacherName: this_.new_schedule.teacherName,
                roomId: this_.new_schedule.roomId,
                roomName: this_.new_schedule.roomName,
                type:this_.new_schedule.type,
                teaType:this_.new_schedule.teaType,
                isAttendance:this_.new_schedule.isAttendance
              }
            }).then(function (resp) {
              let data = resp.data;
              if (data.success) {
                this_.initTrainingScheduleData();
                if(data.message == 'success') {
                  "保存成功".showMessage();
                }else{
                  ("数据已保存，存在数据冲突如下：<br/>" + data.message.replaceAll("\n", "<br/>")).showMessage();
                }
                $("#myModal").modal("hide");
              } else {
                data.message.showMessage();
              }
            });
          }
        });
      },
      validateAllLesson(){
        let this_ = this;
        schoolAxios({
          method: 'get',
          url: "lesson/validateAll",
          params: {
            clazzId: this_.clazzId
          }
        }).then(function (resp) {
          let data = resp.data;
          if (data.success) {
            if(data.message == 'success') {
              "验证完成，无冲突数据".showMessage();
            }else{
              ("存在数据冲突如下：<br/>" + data.message.replaceAll("\n", "<br/>")).showMessage();
            }
          } else {
            data.message.showMessage();
          }
        });
      },
      /**
       * 修改日程数据
       */
      updateSchedeleMsg(lessonStatus){
        let this_ = this;
        this_.scheduleStatus=lessonStatus;
        schoolAxios({
          method: 'get',
          url: 'lesson/load/'+this_.update_schedule_id,
          params: {}
        }).then(function (resp) {
          let data = resp.data;
          console.log('------------------data:',data)
          if(data.success){
            this_.new_schedule = data.data;
            //this_.new_schedule.teacherId =data.data.teacherId;
            if(this_.new_schedule.teacherId){
              this_.checkbox.checkIds = this_.new_schedule.teacherId.split(",");
            }else {
              this_.checkbox.checkIds=[];
            }
            if(this_.new_schedule.teaType){
              this_.checkbox.teaTypes = this_.new_schedule.teaType.split(",");
            }else {
              this_.checkbox.teaTypes=[];
            }
            if(this_.new_schedule.teacherName){
              this_.checkbox.teacherNames = this_.new_schedule.teacherName.split(",");
              this_.checkbox.checkIds.length = this_.checkbox.teacherNames.length;//同步两数组长度，补空
              this_.checkbox.teaTypes.length = this_.checkbox.teacherNames.length;//同步两数组长度，补空
            }else {
              this_.checkbox.teacherNames=[]
            }
            if( this_.new_schedule.courseId){
              this_.searchCourseNameComplete = true;
            }else{
              this_.searchCourseNameComplete = false;
            }
            // this_.searchTeacherName = data.data.teacherName;
            this_.searchCourseName = data.data.name;
            this_.attendanceLoadCul(this_.new_schedule.isAttendance);
            $("#myModal").modal("show");
            console.log(this_.scheduleStatus);
          }
        });
      },
      /**
       * 删除日程
       */
      deleteSchedeleMsg(){
        let this_ = this;
        "确定删除日程".showConfirm(function () {
          schoolAxios({
            method: 'get',
            url: 'lesson/delete/'+this_.delete_schedule_id,
            params: {}
          }).then(function (resp) {
            let data = resp.data;
            if(data.success){
              this_.initTrainingScheduleData();
            }else{
              "删除失败".showMessage();
            }
          });
        });
      },

      removeDiv(){
        $("#teachers_div").hide();
        $("#course_div").hide();
        // $(".room_div").hide();
        // $("#time_div").hide();
      },

      /**
       * 关闭模态框监听
       */
      closeModal() {
        let this_ = this;
        $("#myModal").on('hide.bs.modal', function () {
          this_.searchTeacherName = '';
          this_.searchCourseName = '';
          this_.queryInputDataArr = [];
          this_.new_schedule = {
            unitId: '',
            id: '',
            startDate: '',
            time: '',
            name: '',
            teacherId: '',
            teacherName: '',
            roomId: '',
            roomName: '',
            type:'',
            isAttendance:''
          };
          this_.attendanceValueOne = '1';
          this_.attendanceValueTwo = "1";
          this_.placeId = '';
          this_.roomId = '';

          this_.isShowRoomDiv = false;
          this_.roomsList = [];
          this_.scheduleStatus='';
          this_.resetCourse();
          // this_.checkbox.teacherNames=[];

          // $(".room_div").hide();
          $("#time_div").hide();

          setTimeout(function () {
            this_.errors.clear('training');
          });

        });
      },


      cancelSaveSchedule(){
        /*let this_ = this;
        this_.new_schedule= {
          unitId: '',
          id: '',
          startDate: '',
          time: '',
          name: '',
          teacherId: '',
          teacherName: '',
          roomId: '',
          roomName: '',
          type:''
        }
        //上课教师搜索
        this_.searchTeacherName= '';
        this_.queryInputDataArr= [];

        //课程库课程名称搜索
        this_.searchCourseName='';
        //课程库集合
        this_.courseInputDataArr=[];
        //教师falg
        this_.teacherFlag=0;
        //教师ids
        this_.checkbox= {
          checkIds: [],
          teacherNames:[]
        };*/
        $("#myModal").modal("hide");
      },
      addTeacher(opt){
        let this_ = this;
        if(opt == 0){
          if(this_.searchTeacherName){
            if(this_.selectedIndex >= 0 && this_.queryInputDataArr && this_.selectedIndex < this_.queryInputDataArr.length){
              let d = this_.queryInputDataArr[this_.selectedIndex];
              this_.selectedIndex = -1;
              this_.chooseTeachers(d.id, d.userName, d.hasOwnProperty('teaType')?d.teaType:'0');
            }else{
              this_.checkbox.checkIds.push(null);
              this_.checkbox.teaTypes.push('0');
              this.checkbox.teacherNames.push(this_.searchTeacherName);
            }
            this_.searchTeacherName = null;
            $("#teachers_div").hide();
          }
          return;
        }

        if(this_.queryInputDataArr && this_.queryInputDataArr.length>0){
          if(opt == -1){
            if(this_.selectedIndex <= 0) return;
            else this_.selectedIndex -= 1;
          }else if(opt == 1){
            if(this_.selectedIndex == this_.queryInputDataArr.length-1) return;
            else this_.selectedIndex += 1;
          }
          this_.searchTeacherName = this_.queryInputDataArr[this_.selectedIndex].userName;
        }
      },
      /**
       * 联想查询班主任信息-add
       */
      loadQueryInputDataWhenAdd(flag, event){
        console.log('-------------------------loadQueryInputDataWhenAdd')
        console.log('-------------------------this.checkbox.teacherNames:',this.checkbox.teacherNames)
        if(event && (event.keyCode == 13 //回车
          ||event.keyCode == 38//上键
          ||event.keyCode == 40 ))//下键
          return;
        let this_ = this;
        if(flag == 0) {
          this_.selectedIndex = -1;
          this_.new_schedule.teacherId = "";
          this_.new_schedule.teacherName = "";
          if (this_.searchTeacherName != "") {

            //后台查询数据赋值
            schoolAxios({
              method: 'get',
              url: 'user/queryUserSchoolByUserName',
              params: {
                'userName': this_.searchTeacherName
              }
            }).then(function (resp) {
              let data = resp.data;
              if (data.success) {
                this_.queryInputDataArr = data.list;
                //查询外聘
                schoolAxios({
                  method: 'get',
                  url: 'description/list',
                  params: {
                    name: this_.searchTeacherName,
                    type:3
                  },
                }).then(function (DescriptionListresp) {
                  DescriptionListresp.data.list.forEach(i=>{
                    let flag = true
                    i.teaType = '1'
                    this_.queryInputDataArr.forEach(j=>{
                      if(j.id == i.id){
                        flag = false
                      }
                    })
                    if(flag){
                      this_.queryInputDataArr.push(i)
                    }
                  })
                  $("#teachers_div").show();
                });
              }
            });
          } else {
            this_.queryInputDataArr = [];
          }
        }else {
          this_.new_schedule.teacherId = "";
          this_.new_schedule.teacherName = "";
          if (this_.new_schedule.courseId != "") {
            schoolAxios({
              method: 'get',
              url: 'course/getTeachers',
              params: {
                'id': this_.new_schedule.courseId,
                'status':'1'
              }
            }).then(function (resp) {
              let data = resp.data;
              if (data.success) {
                this_.queryInputDataArr = data.list;
                if(this_.queryInputDataArr && this_.queryInputDataArr.length>0)//有教员才弹出显示
                  $("#myModal_course").modal("show");
                // $("#teaCourse_div").show();
              }
            });
          }else {
            this_.queryInputDataArr = [];
          }
        }
        console.log('-------------------------this.checkbox.teacherNames后：',this.checkbox.teacherNames)
        console.log('-------------------------loadQueryInputDataWhenAdd结束')
      },
      /*   showTeachersDiv(){
           $("#teachers_div").show();
         },
         hideTeachersDiv(){
           $("#teachers_div").hide();
         },
         showTeachersDiv(){
           $("#teaCourse_div").show();
         },
         hideTeachersDiv(){
           $("#teaCourse_div").hide();
         },*/
      /**
       * 新增老师时获得数据
       */
      putTeacherData(index){
        let this_ = this;
        if(index >= 0){
          let data = this_.queryInputDataArr[index];
          this_.new_schedule.teacherId = data.id;
          this_.new_schedule.teacherName = data.userName;
          // this_.new_schedule.teacherId
          this_.searchTeacherName = data.userName;
          $("#teachers_div").hide();
        }
      },
      /**
       * 新增老师时获得数据（课程库）
       */
      putTeaCourseData(index){
        let this_ = this;
        if(index >= 0){
          let data = this_.courseInputDataArr[index];

          this_.new_schedule.teacherId = data.id;
          this_.new_schedule.teacherName = data.teadherName;
          /* this_.new_schedule.type = data.type;*/
          this_.searchTeacherName = data.teadherName;
          /*  $("#teaCourse_div").hide();*/
        }
      },
      checkedOne (id,teacherName,teaType) {
        let this_ = this;
        let idIndex = this_.checkbox.checkIds.indexOf(id);
        if (idIndex >= 0) {//如果已经包含就去除
          this_.checkbox.checkIds.splice(idIndex, 1);
          this_.checkbox.teacherNames.splice(idIndex, 1);
          this_.checkbox.teaTypes.splice(idIndex, 1);
        } else {//如果没有包含就添加
          this_.checkbox.checkIds.push(id);
          this_.checkbox.teacherNames.push(teacherName);
          this_.checkbox.teaTypes.push(teaType);
        }
      },
      teaCourseDivHide() {
        let this_ = this;
        this_.new_schedule.teacherId = this_.checkbox.checkIds.toString();
        this_.new_schedule.teaType = this_.checkbox.teaTypes.toString();
        this_.new_schedule.teacherName = this_.checkbox.teacherNames.toString();
        this_.searchTeacherName = this_.checkbox.teacherNames.toString();
        this_.searchTeacherName = '';
        $("#teaCourse_div").hide();
        $("#myModal_course").modal("hide");
        // this_.uniq(this_.checkbox.teacherNames);
      },


      chooseTeachers(id, teacherName, teaType,selected){
        let this_ = this;
        let idIndex = this_.checkbox.checkIds.indexOf(id);
        let teachers=[];
        if (idIndex >= 0) {//如果已经包含就去除
          if(selected === true) {
            this_.checkbox.checkIds.splice(idIndex, 1);
            this_.checkbox.teacherNames.splice(idIndex, 1);
            this_.checkbox.teaTypes.splice(idIndex, 1);
          }
        } else {//如果没有包含就添加
          this_.checkbox.checkIds.push(id);
          this_.checkbox.teaTypes.push(teaType);
          this_.checkbox.teacherNames.push(teacherName);
        }
        //this_.searchTeacherName = this_.checkbox.teacherNames.toString();
        this_.searchTeacherName = '';
        $("#teachers_div").hide();
      },

      deleteTeacherById(index){
        let this_=this;
        this_.checkbox.checkIds.splice(index, 1);
        this_.checkbox.teacherNames.splice(index, 1);
        this_.checkbox.teaTypes.splice(index, 1);
      },


      /**
       * 新增教学内容时获得数据
       */
      /*putCourseData(index){
        let this_ = this;
        if(index >= 0){
          let data = this_.courseInputDataArr[index];
          // this_.new_schedule.id = data.id;
          this_.new_schedule.name = data.name;
          this_.new_schedule.type = data.type;
          this_.teacherFlag = 1;
          this_.searchCourseName = data.name;
          this_.loadQueryInputDataWhenAdd(1);
          $("#course_div").hide();
          $("#myModal_course").modal("show");
        }
      },*/

      showTeacherModal(){
        this.teacherFlag = 0;
        $("#myModal_course").modal("show");
      },

      hideTeacherModal(){
        this.teacherFlag = 0;
        $("#myModal_course").modal("hide");
      },

      /**
       * 联想查询课程库信息-add
       */
      loadCourseInputDataWhenAdd(event){
        let this_ = this;
        if(event && (event.keyCode == 13 //回车
          ||event.keyCode == 38//上键
          ||event.keyCode == 40 ))//下键
          return;
        if(this_.searchCourseNameComplete && event && (event.keyCode == 8 || event.keyCode == 48 )){//选择后删除
          this_.resetCourse();
          return;
        }

        this_.new_schedule.name = "";
        this_.teacherFlag = 1;
        if(this_.searchCourseName != ""){
          //后台查询数据赋值
          schoolAxios({
            method: 'get',
            url: 'course/findCourseListByName',
            params: {
              'name': this_.searchCourseName
            }
          }).then(function (resp) {
            let data = resp.data;
            if(data.success){
              this_.courseInputDataArr = data.list;
              $("#course_div").show();
            }
          });
        }else{
          this_.courseInputDataArr= [];
        }
      },
      addCourse(opt){
        let this_ = this;
        if(opt == 0){
          if(this_.searchCourseName){
            if(this_.selectedIndex >= 0 && this_.courseInputDataArr && this_.selectedIndex < this_.courseInputDataArr.length){
              let d = this_.courseInputDataArr[this_.selectedIndex];
              this_.selectedIndex = -1;
              this_.chooseCourse(d);
            }
            $("#course_div").hide();
          }
          return;
        }

        if(this_.courseInputDataArr && this_.courseInputDataArr.length>0){
          if(opt == -1){
            if(this_.selectedIndex <= 0) return;
            else this_.selectedIndex -= 1;
          }else if(opt == 1){
            if(this_.selectedIndex == this_.courseInputDataArr.length-1) return;
            else this_.selectedIndex += 1;
          }
          console.log(this_.courseInputDataArr,this_.selectedIndex )
          this_.searchCourseName = this_.courseInputDataArr[this_.selectedIndex].name;
        }
      },
      chooseCourse(course){
        let this_ = this;
        this_.new_schedule.name = course.name;
        this_.new_schedule.courseId = course.id;
        this_.new_schedule.takeHours = course.takeHours;
        this_.searchCourseName = course.name;
        this_.searchCourseNameComplete = true;
        this_.loadQueryInputDataWhenAdd(1);
        $("#course_div").hide();

      },
      resetCourse(){
        let this_ = this;
        this_.new_schedule.name = "";
        this_.new_schedule.courseId = "";
        this_.new_schedule.takeHours = 4;
        this_.searchCourseName = "";
        this_.searchCourseNameComplete = false;
        this_.courseInputDataArr = [];
        this_.queryInputDataArr = [];
      },
      hideCourseDiv(){
        $("#course_div").hide();
      },
      /* showTeachersDiv(){
         $("#course_div").show();
       },
       hideTeachersDiv(){
         $("#course_div").hide();
       },*/

      showTimeDiv(){
        $("#time_div").show();
      },
      hideTimeDiv(){
        $("#time_div").hide();
      },
      putTimeData(index){
        let this_ = this;
        if(index >= 0) {
          let data = this_.lesson_time[index];

          this_.new_schedule.time = data;
          $("#time_div").hide();
        }else {
          //this_.new_schedule.time = "";
          $("#time_div").hide();

          $("#myModal_time").modal("show");
        }
      },

      chooseTimeOk(){
        let this_ = this;
        this_.$validator.validateAll('selfTime').then(result => {
          if (result) {
            this_.new_schedule.time = this_.selfTime.startTime + "-" + this_.selfTime.endTime;
            $("#myModal_time").modal("hide");
          }
        });
      },

      chooseTimeBySelf(){
        let this_ = this;

        $("#myModal_time").modal("show");
      },


      /**
       * 根据老师姓名查询课程
       */
      /*  queryCoursesByTeacherName(){
          let this_ = this;
          schoolAxios({
            method: 'get',
            url: 'description/list',
            params: {
              clazzId:this_.clazzId,
              name: this_.searchTeacherName,
            },

          }).then(function (resp) {
            let data = resp.data;
            if(data.success){
              // this_.trainingScheduleList = data.list;
              this_.initTrainingScheduleData();
            }
          });
        },
  */
      /**
       * 导出班级考勤
       */
      exportAttendance(){
        let this_=this;
        /*location.href=this_.hrefExport+'?clazzId='+this_.clazzId+'&access_token='+this_.token;*/
        schoolAxios({
          method: 'get',
          url:'attendance/getClazzAttendanceExcel',
          params: {
            "clazzId":this_.clazzId,
            "access_token":this_.token
          }
        }).then(function (response) {
          location.href=this_.hrefExport+response.data.data;
        });
      },
      /**
       * 导出培训日程
       */
      exportLesson(){
        let this_=this;
        schoolAxios({
          method: 'get',
          url:'unit/exportUnitLesson',
          params: {
            "clazzId":this_.clazzId,
            // "access_token":this_.token
          }
        }).then(function (response) {
          location.href=this_.hrefExport+response.data.data;
        });
      },
      /*考勤详情*/
      initAttendanceDetailsList(lessonId,startDate,time,name,teacherName){
        let this_=this;
        schoolAxios({
          method: 'get',
          url: 'attendance/getAttendanceListBy',
          params: {
            "lessonId": lessonId,
            "clazzId":this_.clazzId
          }
        }).then(function (response) {
          // console.info(response);
          let data = response.data;
          if (data.success) {
            this_.new_schedule.startDate = startDate;
            this_.new_schedule.time = time;
            this_.new_schedule.name = name;
            this_.new_schedule.teacherName = teacherName;
            this_.attendanceDetailsList = data.list;
          }
        });
      },
      /**
       * 发送短信
       */
      sendMessage(){
        let this_ = this;
        this_.canClickAgain = true;
        this_.timeNum = 180;
        //定时执行
        let t1 = window.setTimeout(function () {
          this_.canClickAgain = false;
          window.clearTimeout(t1);
        }, 1000 * 180);
        let t2 = window.setInterval(function () {
          this_.timeNum -= 1;
          if(this_.timeNum == 0){
            this_.timeNum = '';
            window.clearInterval(t2);
          }
        }, 1000);
        /*"确定发送短信?".showConfirm(function () {
          schoolAxios({
            method: 'delete',
            url: 'unit/delete/'+this_.delete_unit_id,
            params: {}
          }).then(function (resp) {
            let data = resp.data;
            if(data.success){
              data.message.showMessage();
            }else{
              data.message.showMessage();
            }
          });
        });*/
      },
      /**
       * 自定义ID
       */
      gernerateId_start(id, index){
        return "startDate_"+id+"_"+index;
      },
      gernerateId_end(id, index){
        return "endDate_"+id+"_"+index;
      },

      /**
       * 初始化日期选这框
       */
      dateDefault(){
        let this_ = this;
        let date, nowDate;
        date = new Date();
        nowDate = date.getFullYear() + "-";
        nowDate += (date.getMonth() + 1) + "-";
        nowDate += date.getDate() + " ";
        this_.timeDate = nowDate;
        $('.new_date').datetimepicker({
          minView: "month",
          language: 'zh-CN',
          format: 'yyyy-mm-dd',
          //startDate: this_.timeDate,
          weekStart: 0,
          todayBtn: true,
          clearBtn: true,
          autoclose: true,
          todayHighlight: true,
          startView: 2,
          forceParse: 0,
          showMeridian: 1,
        }).on('hide', function (ev) {
          let id = ev.delegateTarget.id;
          if(id == "startDate"){
            let value = $("#startDate").val();
            this_.new_unit.startDate = value;
          }else if(id == "endDate"){
            let value = $("#endDate").val();
            this_.new_unit.endDate = value;
          }else if(id == "new_schedule_startDate"){
            let value = $("#new_schedule_startDate").val();
            this_.new_schedule.startDate = value;
          }else{
            let id_ = id.substring(id.indexOf("_")+1, id.lastIndexOf("_"));
            let index_ = id.substring(id.lastIndexOf("_")+1);
            let value = $("#"+id).val();
            if(id.indexOf("startDate") != -1){
              this_.trainingScheduleList[index_].startDate = value;
            }else{
              this_.trainingScheduleList[index_].endDate = value;
            }
          }

          ev.preventDefault();
          ev.stopPropagation();
        });
      },
      changeLessonStart(lesson){
        this.changeLessonStatus = 1;
        this.changeLessonInTwoData = [lesson];
      },
      changeLessonClear(){
        this.changeLessonStatus = 0;
        this.changeLessonInTwoData = [];
      },
      changeLessonSelect(lesson){
        this.changeLessonStatus = 1;
        this.changeLessonInTwoData[1] = lesson;
        let lesson1 = this.changeLessonInTwoData[0];
        let lesson2 = this.changeLessonInTwoData[1];
        let message = "课程【" + lesson1.name + "】时间【" + lesson1.startDate + " " + lesson1.time + "】教师【" + lesson1.teacherName + "】";
        message += "<br/>";
        message += "对调";
        message += "<br/>";
        message += "课程【" + lesson2.name + "】时间【" + lesson2.startDate + " " + lesson2.time + "】教师【" + lesson2.teacherName + "】"
        message += "<br/>";
        message += "是否继续？";
        let ids = [];
        ids[0] = lesson1.id;
        ids[1] = lesson2.id;
        let this_ = this;
        message.showConfirm(function () {
          schoolAxios({
            method: 'put',
            url: 'lesson/exchange',
            data: {ids:ids}
          }).then(function (resp) {
            let data = resp.data;
            if(data.success){
              this_.initTrainingScheduleData();
              this_.changeLessonClear();
            }else{
              (data.message||"课程对调失败").showMessage();
            }
          });

        })
      },
      notice(id){
        schoolAxios({
          method: 'put',
          url: 'lesson/notice',
          data: {id:id}
        }).then(function (resp) {
          let data = resp.data;
          if(data.success){
            "课程通知已发送".showMessage();
          }else{
            (data.message||"课程通知发送失败").showMessage();
          }
        });

      }
    },




  }
</script>

<style scoped>
  @import '../assets/css/plugins.css';
  @import "../assets/css/publicStyle.css";
  .unit_all {
    width: 100%;
    height: 86%;
    overflow: auto;
    /*background-color: #D7D7D7;*/
    /*padding: 10px 0 0 0;*/
  }
  .unit_name_title {
    margin-bottom: 10px;
    font-size: 18px
  }
  .unit_one {
    width: 100%;
    /*background-color: #CCCCCC;*/
    margin: 20px 0 20px 0px;
    border: 1px dashed #919191;
  }
  .table {
    width: 96%;
    text-align: center;
    margin: 25px 2% 25px 2%;
  }
  .table th {
    text-align: center;
    color: black;
    background-color: #CCCCCC;
  }
  .table tr {
    color: black;
    background-color: #FFFFFF;
  }
  .unit_one_content_header_div{
    width: 96%;
    margin: 10px 2% 0 2%;
  }
  .unit_one_content_header_line {
    width: 80%;
    border: 1px solid #A2A2A2;
    margin: 0 20% 0 0;
    float: right;
  }

  p{
    margin: 10px 0px;
  }

  .class_head_title_font {
    width: 12%;
  }
  .add_unit {
    width: 150px;
    font-size: 18px;
    margin: 10px 0 0 0px;
    border-radius: 5px;
    height: 40px;
  }
  .add_schedule {
    width: 115px;
    font-size: 15px;
    height: 35px;
    border-radius: 5px;
    margin: 0 2% 10px 2%;
  }
  .unit_action_edit {
    width: 29px;
    height: 22px;
    background-image: url("../assets/img/right/clazz/edit.png");
    background-size: 100% 100%;
    float: left;
    margin: 0 15px 0 0;
  }
  .unit_action_edit:hover{
    width: 29px;
    height: 22px;
    background-image: url("../assets/img/right/clazz/edit_mouseOver.png");
    background-size: 100% 100%;
  }
  .unit_action_delete {
    width: 29px;
    height: 22px;
    background-image: url("../assets/img/right/clazz/delete.png");
    background-size: 100% 100%;
    float: left;

  }
  .unit_action_delete:hover{
    width: 29px;
    height: 22px;
    background-image: url("../assets/img/right/clazz/delete_mouseOver.png");
    background-size: 100% 100%;
  }
  .unit_action {
    float: right;
    /*margin: 5px 55px 0 0;*/
  }
  .modal-content {
    position: absolute;
    /*top: 50%;*/
    left: 50%;
    transform: translate(-50%, 0);
    width: 400px;
    height: 600px;
  }
  .modal-title {
    text-align: center;
  }
  .modal-body {
    text-align: center;
    height: 480px;
    overflow: auto;
  }
  .modal-footer {
    text-align: center;
  }
  .trainingSchedule_form input,.trainingSchedule_form select {
    width: 100%;
    height: 32px;
    margin: 20px 0 0px 0;
  }
  .btn_save , .btn_cancel{
    /*height: 40px;*/
  }

  .unit_add_div {
    width: 95%;
    background-color: #CCCCCC;
    margin: 10px 0 27px 20px;
    border: 1px dashed #919191;
  }
  .unit_name{
    width: 300px;
    height: 35px;
    margin: 0 0 10px 0;
  }
  .unit_startDate,.unit_endDate {
    width: 145px;
    height: 35px;
  }

  .unit_content {
    width: 460px;
    height: 80px;
    margin: 0 0 0 20px;
  }

  .unit_startDate,.unit_dateMiddle,.unit_endDate{
    float: left;
  }
  .unit_add_table,.unit_add_div_p {
    margin: 10px 10px 0 40px;
  }
  .unit_save,.unit_cancel {
    width: 115px;
    height: 32px;
    border-radius: 5px;
  }
  .form_unit {
    margin: 20px 0 0 0;
  }
  .form_unit label {
    float: left;
  }
  label.unit_content_label {
    position: relative;
    top: -23px;
  }
  .form_unit input{
    width: 60%;
    float: right;
    margin: 0 32% 0 0;
  }
  #form_unit_startTime {
    width: 10%;
    margin: 0 82% 0 0;
  }
  #form_unit_endDate {
    width: 10%;
    margin: 0 70% 0 0;
  }
  .detailBtn {
    /*width: 120px;*/
    /*line-height: normal;*/
  }
  .okBtn[data-v-0dd82921] {
    /*width: 50px;*/
    line-height: 15px;
  }

  .form-control {
    display: unset;
    width: 25%;
  }
  .form-group-div {
    margin-top: 10px;
  }
  .form-group label {
    width: 100px;
  }

  .table>tbody>tr>td {
    line-height: 30px;
  }


  #teachers_div {
    position: absolute;
    left: 26px;
    width: 84%;
    border: 1px grey solid;
    background-color: white;
    display: none;
    z-index: 1000;
  }
  #teachers_div option {
    height: 30px;
    line-height: 30px;
    text-align: left;
  }
  #teachers_div option:hover {
    background-color: grey;
  }

  #course_div {
    position: absolute;
    left: 26px;
    width: 84%;
    border: 1px grey solid;
    background-color: white;
    display: none;
    z-index: 1;
  }
  /*.course_div {
    position: absolute;
    left: 24px;
    width: 85%;
    border: 1px grey solid;
    background-color: white;
    display: none;
    z-index: 1;
  }*/
  #course_div option {
    height: 30px;
    line-height: 30px;
    text-align: left;
  }
  #course_div option:hover {
    background-color: grey;
  }


  #teaCourse_div {
    position: absolute;
    left: 23px;
    width: 84%;
    /*border: 1px grey solid;*/
    /*display: none;*/
  }
  #teaCourse_div option {
    height: 30px;
    line-height: 30px;
    text-align: left;
  }
  #teaCourse_div option:hover {
    background-color: grey;
  }

  #time_div {
    position: absolute;
    left: 26px;
    width: 84%;
    border: 1px grey solid;
    background-color: white;
    display: none;
    z-index: 1;
  }
  #time_div option {
    height: 30px;
    line-height: 30px;
    text-align: left;
  }
  #time_div option:hover {
    background-color: grey;
  }

  .room_div {
    position: absolute;
    left: 24px;
    width: 85%;
    border: 1px grey solid;
    background-color: white;
    display: none;
    z-index: 1000;
  }
  .room_div option {
    height: 30px;
    line-height: 30px;
    text-align: left;
  }
  .room_div option:hover {
    background-color: grey;
  }

  /*.lesson_div option {
    height: 30px;
    line-height: 30px;
    text-align: left;
  }
  .lesson_div option:hover {
    background-color: grey;
  }*/

  .isShowRoomDivClass {
    display: block;
  }

  #myTab li {
    border: 1px solid black;
    padding: 5px;
    margin: 5px;
    border-radius: 5px;
    background-color:#ff6f66 ;
    color: #FFFFFF;
  }
  #myTab_ li {
    border: 1px solid black;
    padding: 5px;
    margin: 5px;
    border-radius: 5px;
    background-color:#f9efd8;
    color: #000;
  }
  #myTab li:hover {
    background-color: #ff2e2f;
  }
  #myTab_ li:hover {
    background-color: #ffe60d;
  }

  .havenClick {
    background-color: grey;
  }

  input.form-control.scheduleInfo {
    display: inline-block;
    width: 92%;
  }
  select.form-control.scheduleInfo {
    display: inline-block;
    width: 92%;
  }

  .validateTip_unit {
    text-align: left;
    padding-left: 100px;
  }

  .okBtn {
    line-height: normal;
  }

  #myModal_time {
    z-index: 99999;
  }
  .unit_content_label-name {
    position: relative;
    top: -10px;
  }
  .teaCourse_table_action{
    padding: 0 auto;
    margin: 0 auto;
    height: auto;
  }
  .teaCourse_table_action input{
    height: 15px;
    margin: 0 0 10px 0;
  }
  .teaCourse_table_action td:nth-child(2){
    /*padding-right: 100px;*/
    width: 70%;
  }
  .teaCourse_table_action {
    width: 100%;
    /*text-align: left;*/
    margin: 10px 0 25px 0;
  }
  .teaCourse_table_action tr {
    color: black;
  }
  .teacherBtn {
    margin: 2px 0 0 5px;
  }
  .query_course_div {
    width: auto;
    position: absolute;
    top: 0%;
    right: 10px;
    /*background-color: #b9def0;*/
  }
  .btn_export {
    margin:2px 0 0 2px;
  }
  .lesson_table tbody{
    height: auto;
  }
  .details_table tbody{
    height: 300px;
  }
  .details_content {
    width: 900px;
    height: auto;
  }
  .body_top {
    /*margin: 0 37% 0 0;*/
  }
  .body_top span {
    margin-left: 20px;
  }
  .panel.panel-default {
    margin: 10px 0 0 8px;
    width: 93%;
  }
  .teacher_input {
    float: left;
  }
  input.form-control.scheduleInfo.teacher_input {
    width: 89%;
  }
  .panel-heading {
    padding: 0;
    height: 60px;
  }
  .teacher_name_div {
    /*width: 80px;*/
    height: 25px;
    float: left;
    margin: 3px;
    padding: 3px;
    background-color: #ccc;
    border: 1px #ffe60d solid ;
    /*background-color: #ff6f66;*/
  }

  .glyphicon {
    display: inline-block;
  }
  .glyphicon-remove {
    font-size: 10px;
  }
  .glyphicon-remove:hover{
    color: #ff6f66;
  }
  input.form-control.scheduleInfo.tea_input {
    margin-right: 3%;
    width: 80%;
  }
  .course_content {
    height: 350px;
  }
  .course_footer {
    /*height: 20%;*/
  }

  .course_dialog {
    /*height: 500px;*/
  }
  .course_body {
    /*height: 50%;*/
    overflow: hidden;
  }
  #myModal_course .modal-body{
    height: 200px;
    text-align: left;
  }
  #myModal_course .course_content{
    height: 250px;
  }
  #myModal_course #teachers_div_ option{
    display: inline-block;
    margin: 3px;
    width: 100px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    border: 1px solid #0c0c0c;
  }
  #myModal_course #teachers_div_ option:hover, #myModal_course #teachers_div_ .selected, #course_div .selected, #teachers_div .selected{
    background-color: gray;
  }
</style>



// WEBPACK FOOTER //
// src/components/trainingSchedule.vue